import _ from 'lodash';
/**
 *
 * @param url
 * @param params
 * @return {null|*}
 */
export function appendQueryParameters(url, params) {
    if (params === void 0) { params = {}; }
    if (!url) {
        return null;
    }
    var newUrl = url;
    var questionmarkIndex = newUrl.indexOf('?');
    if (newUrl.indexOf('?') < 0) {
        newUrl += '?';
        questionmarkIndex = newUrl.length - 1;
    }
    for (var key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
            if (newUrl.length - 1 > questionmarkIndex) {
                newUrl += '&';
            }
            newUrl += key + '=' + params[key];
        }
    }
    return newUrl;
}
/**
 *
 * @param name
 * @return {string}
 */
export function getQueryParam(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
/**
 *
 */
export function getHashParams() {
    var parameters = window.location.hash.substr(1).split('&');
    var results = {};
    _.each(parameters, function (parameter, index) {
        var segments = parameter.split('=');
        if (segments.length > 1) {
            results[segments[0]] = segments[1];
        }
        else {
            results[index] = segments[0];
        }
    });
    return results;
}
;
